module.exports = "input, select,\n.btn {\n  width: 100%; }\n\n.btn-gray {\n  background: #686868;\n  color: #484848;\n  cursor: not-allowed; }\n\n.type-text {\n  border: 1px solid #c4c4c4;\n  padding: 8px;\n  margin-bottom: 5px;\n  margin-top: 5px;\n  max-width: 100%;\n  min-width: 250px;\n  border-radius: 3px;\n  font-size: 16px; }\n\n#contact-agreement {\n  font-size: 16px;\n  line-height: 20px;\n  text-align: left; }\n\ninput[type=\"radio\"] {\n  display: inline-block;\n  width: 16px; }\n\n.error {\n  font-size: 16px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/personal-information/personal-information.component.scss
// module id = 678
// module chunks = 0